// src/pages/Home.js
import React from 'react';
import Dashboard from '../components/Dashboard';
import Items from './Items';

const Home = () => 
<Dashboard />;

export default Home;
